import {
  getRedirectLoginClient,
  type LoginSession,
} from '@nrk/innlogging-web/redirect-login-client';
import { writable } from 'svelte/store';

export const loginClient = getRedirectLoginClient({});

export const loginSessionStore = writable<LoginSession | null>();

export const forceRefresh = async () => {
  try {
    loginSessionStore.set(await loginClient.forceRefresh());
  } catch {
    //noop
  }
};
